// extracted by mini-css-extract-plugin
export default {"timeline":"TimelineSection_timeline__qodV3"};